
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/technologies/[slug]",
      function () {
        return require("private-next-pages/technologies/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/technologies/[slug]"])
      });
    }
  